/**
 * Installed web modules. The contract a module fulfils is `WebModule` in
 * `@daka/core/web`; the shell renders nav from this registry.
 */
import { createRegistry, type Registry } from '@daka/core';
import type { WebModule } from '@daka/core/web';

export const webModules: Registry<WebModule> = createRegistry('web');
